// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  color: var(--ion-backdrop-color);
  padding: 0 20px;
}

h3 {
  color: #4F614F;
  padding: 0 20px;
  text-transform: none;
}

a {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/components/changed-privacy-policy-modal/changed-privacy-policy-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,eAAA;AACF;;AACA;EACE,cAAA;EACA,eAAA;EACA,oBAAA;AAEF;;AAAA;EACE,iBAAA;AAGF","sourcesContent":["p{\n  color: var(--ion-backdrop-color);\n  padding: 0 20px\n}\nh3{\n  color: #4F614F;\n  padding: 0 20px;\n  text-transform: none;\n}\na{\n  font-weight: bold;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
